export function donorsHasErrored(bool) {
    return {
        type: 'DONORS_HAS_ERRORED',
        donorsHasErrored: bool
    };
}

export function donorsIsLoading(bool) {
    return {
        type: 'DONORS_IS_LOADING',
        donorsIsLoading: bool
    };
}

export function donorsFetchSuccess(donors) {
    return {
        type: 'DONORS_FETCH_SUCCESS',
        donors
    };
}

export function fetchDonors(url, lastUpdated, webkey) {
    return (dispatch) => {
        let now = new Date();
        let rev = now.getTime()/1000;
        if (url.includes('?')){
            url+="&rev="+rev
        }
        else{
            url+="?rev="+rev
        }
        if (webkey){
            url+="&webkey="+webkey
        }
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((donors) => {
                // console.log("donor response");
                // console.log(donors);
                if (Number(donors.last_update)>Number(lastUpdated)){
                    dispatch(donorsFetchSuccess(donors))    
                }
                else{
                    return null;
                }
            }).catch((error) => {
                dispatch(donorsHasErrored(true));   
            });
    };
}


// WEBPACK FOOTER //
// ./src/actions/donors.js